import React, { useEffect, useState } from "react";
import { getProfileImageUrl } from "helpers/Image.helper";
import { getStudentNickname, getFlagByCountryCode, getStudentName, getCurrentLangName } from "helpers/String.helper";
import LoadingComponent from "commons/loading/Loading.component";
import * as HomeApi from "api/school/v2/student/home.api";
import { IStudentHomeInfoParams } from "api/school/v2/student/home.api";
import ApplyingRequestPopup from "../../popup/ApplyingRequestPopup";
import { usePopup } from "contexts/PopupContext";

interface StudentListProps { }

const StudentList: React.FC<StudentListProps> = () => {
    const { showPopup } = usePopup();
    const [list, setList] = useState<IStudentHomeInfoParams['requestedStudentList']>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isInit, setIsInit] = useState(false);

    useEffect(() => {
        fetchStudentList();
    }, []);

    const fetchStudentList = async () => {
        setIsLoading(true);
        try {
            const response = await HomeApi.getStudentHomeInfo();
            if (response?.requestedStudentList) {
                setList(response.requestedStudentList);
                setIsInit(true);
            }
        } catch (error) {
            console.error("학생 목록 조회 실패:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const onClickStudent = (student: any) => {
        showPopup(
            <ApplyingRequestPopup
                isInit={true}
                info={student}
                onClose={() => {
                    // 팝업이 닫힐 때 필요한 로직이 있다면 여기에 추가
                }}
                onReject={() => {
                    // 가입 요청 거절 로직
                    console.log("가입 요청 거절:", student?.userStudent.id);
                    // TODO: API 호출하여 거절 처리
                }}
                onAccept={() => {
                    // 가입 요청 수락 로직
                    console.log("가입 요청 수락:", student?.userStudent.id);
                    // TODO: API 호출하여 수락 처리
                }}
                onDetailInfo={() => {
                    // 학생 상세 페이지로 이동
                    if (student?.userStudent.id) {
                        window.location.href = `/school/student/${student.userStudent.id}`;
                    }
                }}
            />
        );
    };

    if (!isInit) {
        return (
            <div className="mb-6">
                <LoadingComponent />
            </div>
        );
    }

    if (isLoading) {
        return <LoadingComponent />;
    }

    if (list.length === 0) {
        return (
            <div className="text-center py-10">
                <p className="text-gray-500">등록된 학생이 없습니다.</p>
            </div>
        );
    }

    return (
        <div className="mb-8">
            <div className="p-2 sm:p-3 flex items-center">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900">
                    가입 요청 학생 목록
                </h2>
            </div>
            <div className="overflow-x-auto">
                <div className="flex gap-0.25">
                    {list.map((item, index: number) => (
                        <div
                            key={index}
                            className="w-[95px] sm:w-[120px] lg:w-[145px] flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
                            onClick={() => onClickStudent(item)}
                        >
                            <div className="flex flex-col items-center">
                                <div className="rounded-full overflow-hidden w-14 h-14 sm:w-16 sm:h-16 flex-shrink-0 border-2 border-gray-100 relative">
                                    <img
                                        src={getProfileImageUrl(item.userStudent.profileImage, 200)}
                                        alt={getStudentName(item.userStudent)}
                                        className="w-full h-full object-cover"
                                    />
                                    {item.userStudent.lastProfileUpdatedAt && (
                                        <div className="absolute top-0 right-0 w-3 h-3 bg-[#CF3688] rounded-full"></div>
                                    )}
                                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 text-lg">
                                        {getFlagByCountryCode(item.userStudent.countryCode)}
                                    </div>
                                </div>
                                <div className="mt-1 text-center w-full">
                                    <p className="text-gray-900 text-xs truncate px-1">
                                        {item.userStudent.lastName} {item.userStudent.firstName}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-1">
                                        {item.userStudent.birthday ?
                                            new Date().getFullYear() - new Date(item.userStudent.birthday).getFullYear() + '세' :
                                            '나이 정보 없음'
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StudentList; 